import { render } from "./TreeNode.vue?vue&type=template&id=745f055b&scoped=true&ts=true"
import script from "./TreeNode.vue?vue&type=script&lang=ts"
export * from "./TreeNode.vue?vue&type=script&lang=ts"

import "./TreeNode.vue?vue&type=style&index=0&id=745f055b&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745f055b"]])

export default __exports__